export default __webpack_public_path__ + "static/media/den.4570c980.png";